import React from 'react';
import { useTranslation } from 'react-i18next';
import BasePageComponent from '../../components/BasePageComponent';
import './Contact.css';

const Contact = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <BasePageComponent
      id="contact"
      title={t('contact.title')}
      description={t('contact.description')}
    >
      <div className="contact-buttons">
        <a
          className="contact-button"
          href="https://liff.line.me/1645278921-kWRPP32q/?accountId=474vxczq"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('contact.info.line.button')}
        </a>
        <a
          className="contact-button"
          href="tel:+819069066668"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('contact.info.phone.button')}
        </a>      
      </div>
    </BasePageComponent>
  );
};

export default Contact;